import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdapterEditor from "../../components/adapters/AdapterEditor";
import useLeaveStandaloneEditor from "../../../customHooks/useLeaveStandaloneEditor";

export default function AdaptersDuplicate() {
  const navigate = useNavigate();
  const leave = useLeaveStandaloneEditor("/edge-management/adapters");
  const { adapterId } = useParams<{ adapterId: string }>();

  return (
    <AdapterEditor
      mode="page"
      existingAdapterId={adapterId || undefined}
      formAction="duplicate"
      onSaveSuccess={() => navigate("/edge-management/adapters")}
      onCancel={leave}
    />
  );
}
